import { useMutation } from '@tanstack/react-query'
import updateWhatsNewTour from '../api/whatsnew/updateWhatsNewTour'

const useUpdateWhatsNewTour = () => {
  return useMutation((updateWhatsNewTourObj: any) =>
    updateWhatsNewTour(updateWhatsNewTourObj),
  )
}

export default useUpdateWhatsNewTour
